<template>
  <div>
    <div class="zoom-anim-dialog mfp-hide modal-searchPanel" id="modal-popup-2">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="xs-search-panel">

            <form method="get" action="https://episcloud.com/" class="xs-serach">
              <div class="input-group">
                <input type="search" name="s" placeholder="Search" value="">
                <button class="search-btn"><i class="icon icon-search"></i></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="xs-sidebar-group info-group">
      <div class="xs-overlay xs-bg-black"></div>
      <div class="xs-sidebar-widget">
        <div class="sidebar-widget-container">
          <div class="widget-heading">
            <a href="#" class="close-side-widget">
              X
            </a>
          </div>
          <div class="sidebar-textwidget">
            <div class="sidebar-logo-wraper">
              <img src="../assets/images/facebook_cover_photo_1-removebg-preview.png"
                   alt="Home One">
            </div>
            <p>Far far away, behind the word moun tains, far from the countries Vokalia and Consonantia, there
              live the blind texts. Separated they live in Bookmarksgrove right at the coast of</p>

            <ul class="sideabr-list-widget">
              <li>
                <div class="media">
                  <div class="d-flex">
                    <img src="../assets/images/location.png"
                         alt="">
                  </div>
                  <div class="media-body">
                    <p>16 East 34th Street,New York,</p>
                    <span>NY 10016.</span>
                  </div>
                </div><!-- address 1 -->
              </li>
              <li>
                <div class="media">
                  <div class="d-flex">
                    <img src="../assets/images/mail.png"
                         alt="">
                  </div>
                  <div class="media-body">
                    <p>info@episcloud.com</p>
                    <span>Online Support</span>
                  </div>
                </div><!-- address 1 -->
              </li>
              <li>
                <div class="media">
                  <div class="d-flex">
                    <img src="../assets/images/phone.png"
                         alt="">
                  </div>
                  <div class="media-body">
                    <p>+1 508 502 7059</p>
                    <span>Mon-Fri 8am-5pm</span>
                  </div>
                </div><!-- address 1 -->
              </li>
            </ul><!-- .sideabr-list-widget -->

            <div class="subscribe-from">
              <p></p>
              <form id="mc4wp-form-1" class="mc4wp-form mc4wp-form-1428" method="post" data-id="1428"
                    data-name="Newsletter">
                <div class="mc4wp-form-fields">
                  <div id="subscribe-form" class="subscribe-form">
                    <label></label>
                    <div class="form-group">
                      <input type="email" name="EMAIL" id="xs-newsletter-email"
                             placeholder="Enter your mail here"
                             class="form-control">
                      <button class="sub-btn xs_mailchimp_submit" type="submit"><i
                        class="icon icon-arrow-right"></i></button>
                      <input type="hidden" name="list_id" id="xs_list_id" class="xs_list_id"
                             value="<?php echo esc_attr($list_id); ?>">
                    </div>
                  </div>
                  <div class="xs_msg"></div>
                </div>
                <label style="display: none !important;">Leave this field empty if you're human: <input
                  type="text" name="_mc4wp_honeypot" value="" tabindex="-1"
                  autocomplete="off"/></label><input type="hidden" name="_mc4wp_timestamp"
                                                     value="1635264215"/><input type="hidden"
                                                                                name="_mc4wp_form_id"
                                                                                value="1428"/><input
                type="hidden" name="_mc4wp_form_element_id" value="mc4wp-form-1"/>
                <div class="mc4wp-response"></div>
              </form><!-- / Mailchimp for WordPress Plugin -->                        </div>
            <ul class="social-list version-2">
              <li><a href="" class="facebook"><i class="fa fa-facebook"></i></a></li>
            </ul><!-- .social-list -->
            <div class="text-center">
              <a href="" class="btn btn-primary">Purchase Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zoom-anim-dialog mfp-hide modal-language" id="modal-popup-wpml">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="language-content">
            <p>Switch The Language</p>
            <ul class="flag-lists">
              <li><a href="#"><img
                src="../assets/images/006-united-states.svg"
                alt="English"><span>English</span></a></li>
              <li><a href="#"><img
                src="../assets/images/002-canada.svg"
                alt="English"><span>English</span></a></li>
              <li><a href="#"><img
                src="../assets/images/003-vietnam.svg"
                alt="Vietnamese"><span>Vietnamese</span></a></li>
              <li><a href="#"><img
                src="../assets/images/004-france.svg"
                alt="French"><span>French</span></a></li>
              <li><a href="#"><img
                src="../assets/images/005-germany.svg"
                alt="German"><span>German</span></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZoomBar'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ZoomBar.vue